import { ChangeEvent, useCallback, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { InputOption } from '../../types/setting/type'

export const useSetting = () => {
  const [audioInputOptions, setAudioInputs] = useState<InputOption[]>([
    { value: '', label: '' },
  ])
  const [videoInputOptions, setVideoInputs] = useState<InputOption[]>([
    { value: '', label: '' },
  ])
  const [audioInputOption, setAudioInput] = useState<InputOption>({
    value: '',
    label: '',
  })
  const [videoInputOption, setVideoInput] = useState<InputOption>({
    value: '',
    label: '',
  })
  const navigate = useNavigate()
  const fetchDevices = useCallback(async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices()
      const audioInputs: InputOption[] = devices
        .filter((device) => device.kind === 'audioinput')
        .map((device) => ({
          value: device.deviceId,
          label: device.label,
        }))

      const videoInputs: InputOption[] = devices
        .filter((device) => device.kind === 'videoinput')
        .map((device) => ({
          value: device.deviceId,
          label: device.label,
        }))

      setAudioInputs(audioInputs)
      setVideoInputs(videoInputs)

      setAudioInput(audioInputs[0])
      setVideoInput(videoInputs[0])
    } catch (error) {
      console.error('Error fetching devices:', error) // eslint-disable-line no-console
    }
  }, [])

  const onChangeAudio = (e: ChangeEvent<HTMLSelectElement>) => {
    const audio = audioInputOptions.find(
      (input) => input.value === e.target.value
    )
    if (audio) {
      setAudioInput(audio)
    }
  }

  const onChangeVideo = (e: ChangeEvent<HTMLSelectElement>) => {
    const video = videoInputOptions.find(
      (input) => input.value === e.target.value
    )
    if (video) {
      setVideoInput(video)
    }
  }

  const save = () => {
    navigate('/')
  }
  return {
    audioInputOptions,
    videoInputOptions,
    audioInputOption,
    videoInputOption,
    fetchDevices,
    save,
    onChangeAudio,
    onChangeVideo,
  }
}
